
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/diamondhead/about",
      function () {
        return require("private-next-pages/diamondhead/about.js");
      }
    ]);
  